import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'

// Upper bound mirrors scripts/prerender.ts so one base.copy edit adds
// both an FAQ card and a FAQPage JSON-LD entry. Gaps are tolerated:
// if q7/a7 is missing but q8/a8 is defined, q8/a8 still renders.
const MAX_FAQ_ITEMS = 20

export function FAQ() {
  const { t, i18n } = useTranslation()

  const items: number[] = []
  for (let n = 1; n <= MAX_FAQ_ITEMS; n++) {
    if (
      i18n.exists(`lorem:faq.q${n}`) &&
      i18n.exists(`lorem:faq.a${n}`)
    ) {
      items.push(n)
    }
  }

  return (
    <section
      id="faq"
      className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-12 scroll-mt-20"
    >
      <ScrollFade
        as="h2"
        className="text-3xl md:text-4xl font-bold font-display mb-6"
      >
        {t('faq.heading')}
      </ScrollFade>
      <div className="space-y-2">
        {items.map((n) => {
          // Blank lines in base.copy separate paragraphs. Render each
          // as its own <p> so they get real paragraph rhythm instead
          // of collapsing to a single space.
          const paragraphs = t(`lorem:faq.a${n}`)
            .split(/\n\s*\n+/)
            .map((p) => p.trim())
            .filter(Boolean)
          return (
            <details
              key={n}
              className="group marker-dot-card-inline rounded-lg border border-mono-300 dark:border-mono-700 p-5 pr-10"
            >
              <summary className="cursor-pointer text-lg font-semibold list-none flex items-center justify-between gap-4">
                <span>{t(`lorem:faq.q${n}`)}</span>
                <span
                  aria-hidden="true"
                  className="opacity-50 text-2xl leading-none transition-transform group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <div className="mt-3 space-y-3">
                {paragraphs.map((para, i) => (
                  <p
                    key={i}
                    className="text-base opacity-80 leading-relaxed"
                  >
                    {para}
                  </p>
                ))}
              </div>
            </details>
          )
        })}
      </div>
    </section>
  )
}
